var cov_15fkiy65ha = function () {
  var path = "/Users/spana/SHEIN/shineout/src/utils/func.ts",
      hash = "4baade297bdb7c3848147b689de9334f558cd98b",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/utils/func.ts",
    statementMap: {
      "0": {
        start: {
          line: 18,
          column: 2
        },
        end: {
          line: 20,
          column: 3
        }
      },
      "1": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 19,
          column: 21
        }
      },
      "2": {
        start: {
          line: 22,
          column: 2
        },
        end: {
          line: 22,
          column: 61
        }
      },
      "3": {
        start: {
          line: 22,
          column: 27
        },
        end: {
          line: 22,
          column: 61
        }
      },
      "4": {
        start: {
          line: 26,
          column: 2
        },
        end: {
          line: 26,
          column: 20
        }
      },
      "5": {
        start: {
          line: 36,
          column: 2
        },
        end: {
          line: 44,
          column: 3
        }
      },
      "6": {
        start: {
          line: 37,
          column: 4
        },
        end: {
          line: 37,
          column: 29
        }
      },
      "7": {
        start: {
          line: 39,
          column: 4
        },
        end: {
          line: 41,
          column: 5
        }
      },
      "8": {
        start: {
          line: 40,
          column: 6
        },
        end: {
          line: 40,
          column: 29
        }
      },
      "9": {
        start: {
          line: 43,
          column: 4
        },
        end: {
          line: 43,
          column: 24
        }
      },
      "10": {
        start: {
          line: 48,
          column: 2
        },
        end: {
          line: 48,
          column: 45
        }
      },
      "11": {
        start: {
          line: 48,
          column: 34
        },
        end: {
          line: 48,
          column: 45
        }
      },
      "12": {
        start: {
          line: 49,
          column: 2
        },
        end: {
          line: 49,
          column: 67
        }
      },
      "13": {
        start: {
          line: 49,
          column: 42
        },
        end: {
          line: 49,
          column: 66
        }
      },
      "14": {
        start: {
          line: 52,
          column: 24
        },
        end: {
          line: 72,
          column: 1
        }
      },
      "15": {
        start: {
          line: 55,
          column: 6
        },
        end: {
          line: 55,
          column: 8
        }
      },
      "16": {
        start: {
          line: 56,
          column: 21
        },
        end: {
          line: 61,
          column: 3
        }
      },
      "17": {
        start: {
          line: 57,
          column: 4
        },
        end: {
          line: 60,
          column: 5
        }
      },
      "18": {
        start: {
          line: 58,
          column: 6
        },
        end: {
          line: 58,
          column: 30
        }
      },
      "19": {
        start: {
          line: 59,
          column: 6
        },
        end: {
          line: 59,
          column: 23
        }
      },
      "20": {
        start: {
          line: 62,
          column: 2
        },
        end: {
          line: 62,
          column: 39
        }
      },
      "21": {
        start: {
          line: 62,
          column: 14
        },
        end: {
          line: 62,
          column: 39
        }
      },
      "22": {
        start: {
          line: 63,
          column: 2
        },
        end: {
          line: 71,
          column: 3
        }
      },
      "23": {
        start: {
          line: 65,
          column: 6
        },
        end: {
          line: 65,
          column: 18
        }
      },
      "24": {
        start: {
          line: 66,
          column: 6
        },
        end: {
          line: 68,
          column: 15
        }
      },
      "25": {
        start: {
          line: 67,
          column: 8
        },
        end: {
          line: 67,
          column: 21
        }
      }
    },
    fnMap: {
      "0": {
        name: "curry",
        decl: {
          start: {
            line: 17,
            column: 16
          },
          end: {
            line: 17,
            column: 21
          }
        },
        loc: {
          start: {
            line: 17,
            column: 65
          },
          end: {
            line: 23,
            column: 1
          }
        },
        line: 17
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 22,
            column: 9
          },
          end: {
            line: 22,
            column: 10
          }
        },
        loc: {
          start: {
            line: 22,
            column: 27
          },
          end: {
            line: 22,
            column: 61
          }
        },
        line: 22
      },
      "2": {
        name: "empty",
        decl: {
          start: {
            line: 25,
            column: 16
          },
          end: {
            line: 25,
            column: 21
          }
        },
        loc: {
          start: {
            line: 25,
            column: 57
          },
          end: {
            line: 27,
            column: 1
          }
        },
        line: 25
      },
      "3": {
        name: "memoize",
        decl: {
          start: {
            line: 29,
            column: 16
          },
          end: {
            line: 29,
            column: 23
          }
        },
        loc: {
          start: {
            line: 35,
            column: 2
          },
          end: {
            line: 45,
            column: 1
          }
        },
        line: 35
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 36,
            column: 9
          },
          end: {
            line: 36,
            column: 10
          }
        },
        loc: {
          start: {
            line: 36,
            column: 26
          },
          end: {
            line: 44,
            column: 3
          }
        },
        line: 36
      },
      "5": {
        name: "createFunc",
        decl: {
          start: {
            line: 47,
            column: 16
          },
          end: {
            line: 47,
            column: 26
          }
        },
        loc: {
          start: {
            line: 47,
            column: 53
          },
          end: {
            line: 50,
            column: 1
          }
        },
        line: 47
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 49,
            column: 9
          },
          end: {
            line: 49,
            column: 10
          }
        },
        loc: {
          start: {
            line: 49,
            column: 42
          },
          end: {
            line: 49,
            column: 66
          }
        },
        line: 49
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 52,
            column: 24
          },
          end: {
            line: 52,
            column: 25
          }
        },
        loc: {
          start: {
            line: 52,
            column: 65
          },
          end: {
            line: 72,
            column: 1
          }
        },
        line: 52
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 56,
            column: 21
          },
          end: {
            line: 56,
            column: 22
          }
        },
        loc: {
          start: {
            line: 56,
            column: 27
          },
          end: {
            line: 61,
            column: 3
          }
        },
        line: 56
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 64,
            column: 4
          },
          end: {
            line: 64,
            column: 5
          }
        },
        loc: {
          start: {
            line: 64,
            column: 22
          },
          end: {
            line: 69,
            column: 5
          }
        },
        line: 64
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 66,
            column: 30
          },
          end: {
            line: 66,
            column: 31
          }
        },
        loc: {
          start: {
            line: 66,
            column: 36
          },
          end: {
            line: 68,
            column: 7
          }
        },
        line: 66
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 20,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 20,
            column: 3
          }
        }, {
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 20,
            column: 3
          }
        }],
        line: 18
      },
      "1": {
        loc: {
          start: {
            line: 37,
            column: 15
          },
          end: {
            line: 37,
            column: 29
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 37,
            column: 15
          },
          end: {
            line: 37,
            column: 23
          }
        }, {
          start: {
            line: 37,
            column: 27
          },
          end: {
            line: 37,
            column: 29
          }
        }],
        line: 37
      },
      "2": {
        loc: {
          start: {
            line: 39,
            column: 4
          },
          end: {
            line: 41,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 39,
            column: 4
          },
          end: {
            line: 41,
            column: 5
          }
        }, {
          start: {
            line: 39,
            column: 4
          },
          end: {
            line: 41,
            column: 5
          }
        }],
        line: 39
      },
      "3": {
        loc: {
          start: {
            line: 48,
            column: 2
          },
          end: {
            line: 48,
            column: 45
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 48,
            column: 2
          },
          end: {
            line: 48,
            column: 45
          }
        }, {
          start: {
            line: 48,
            column: 2
          },
          end: {
            line: 48,
            column: 45
          }
        }],
        line: 48
      },
      "4": {
        loc: {
          start: {
            line: 49,
            column: 42
          },
          end: {
            line: 49,
            column: 66
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 49,
            column: 49
          },
          end: {
            line: 49,
            column: 59
          }
        }, {
          start: {
            line: 49,
            column: 62
          },
          end: {
            line: 49,
            column: 66
          }
        }],
        line: 49
      },
      "5": {
        loc: {
          start: {
            line: 57,
            column: 4
          },
          end: {
            line: 60,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 57,
            column: 4
          },
          end: {
            line: 60,
            column: 5
          }
        }, {
          start: {
            line: 57,
            column: 4
          },
          end: {
            line: 60,
            column: 5
          }
        }],
        line: 57
      },
      "6": {
        loc: {
          start: {
            line: 62,
            column: 2
          },
          end: {
            line: 62,
            column: 39
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 62,
            column: 2
          },
          end: {
            line: 62,
            column: 39
          }
        }, {
          start: {
            line: 62,
            column: 2
          },
          end: {
            line: 62,
            column: 39
          }
        }],
        line: 62
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

/**
 * from redux.compose https://github.com/reactjs/redux/blob/master/src/compose.js
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
export { compose } from './compose';
export * from './curry';
export function curry(f) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  cov_15fkiy65ha.f[0]++;
  cov_15fkiy65ha.s[0]++;

  if (args.length >= f.length) {
    cov_15fkiy65ha.b[0][0]++;
    cov_15fkiy65ha.s[1]++;
    return f.apply(void 0, args);
  } else {
    cov_15fkiy65ha.b[0][1]++;
  }

  cov_15fkiy65ha.s[2]++;
  return function () {
    cov_15fkiy65ha.f[1]++;
    cov_15fkiy65ha.s[3]++;

    for (var _len2 = arguments.length, next = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      next[_key2] = arguments[_key2];
    }

    return curry.apply(void 0, [f.bind.apply(f, [f].concat(args))].concat(next));
  };
}
export function empty(e) {
  cov_15fkiy65ha.f[2]++;
  cov_15fkiy65ha.s[4]++;
  e.preventDefault();
}
export function memoize(fn) {
  cov_15fkiy65ha.f[3]++;
  cov_15fkiy65ha.s[5]++;
  return function (key) {
    cov_15fkiy65ha.f[4]++;
    cov_15fkiy65ha.s[6]++;
    fn.cache = (cov_15fkiy65ha.b[1][0]++, fn.cache) || (cov_15fkiy65ha.b[1][1]++, {});
    cov_15fkiy65ha.s[7]++;

    if (!(key in fn.cache)) {
      cov_15fkiy65ha.b[2][0]++;
      cov_15fkiy65ha.s[8]++;
      fn.cache[key] = fn(key);
    } else {
      cov_15fkiy65ha.b[2][1]++;
    }

    cov_15fkiy65ha.s[9]++;
    return fn.cache[key];
  };
}
export function createFunc(func) {
  cov_15fkiy65ha.f[5]++;
  cov_15fkiy65ha.s[10]++;

  if (typeof func === 'function') {
    cov_15fkiy65ha.b[3][0]++;
    cov_15fkiy65ha.s[11]++;
    return func;
  } else {
    cov_15fkiy65ha.b[3][1]++;
  }

  cov_15fkiy65ha.s[12]++;
  return function (data) {
    cov_15fkiy65ha.f[6]++;
    cov_15fkiy65ha.s[13]++;
    return func ? (cov_15fkiy65ha.b[4][0]++, data[func]) : (cov_15fkiy65ha.b[4][1]++, data);
  };
}
cov_15fkiy65ha.s[14]++;
export var throttle = function throttle(func, timer) {
  cov_15fkiy65ha.f[7]++;
  var that = (cov_15fkiy65ha.s[15]++, {});
  cov_15fkiy65ha.s[16]++;

  var cleanTimer = function cleanTimer() {
    cov_15fkiy65ha.f[8]++;
    cov_15fkiy65ha.s[17]++;

    if (that.timer) {
      cov_15fkiy65ha.b[5][0]++;
      cov_15fkiy65ha.s[18]++;
      clearTimeout(that.timer);
      cov_15fkiy65ha.s[19]++;
      that.timer = null;
    } else {
      cov_15fkiy65ha.b[5][1]++;
    }
  };

  cov_15fkiy65ha.s[20]++;

  if (!timer) {
    cov_15fkiy65ha.b[6][0]++;
    cov_15fkiy65ha.s[21]++;
    return [func, cleanTimer];
  } else {
    cov_15fkiy65ha.b[6][1]++;
  }

  cov_15fkiy65ha.s[22]++;
  return [function () {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    cov_15fkiy65ha.f[9]++;
    cov_15fkiy65ha.s[23]++;
    cleanTimer();
    cov_15fkiy65ha.s[24]++;
    that.timer = setTimeout(function () {
      cov_15fkiy65ha.f[10]++;
      cov_15fkiy65ha.s[25]++;
      func.apply(void 0, args);
    }, timer);
  }, cleanTimer];
};